import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RevolutionizeImg from "../../images/location_new/fold7/Atlanta.webp";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Why Choose TekRevol for Mobile App Development in Atlanta?</h2>
            <p>
              You can rely on TekRevol's Mobile App Development expertise in
              Atlanta, where the fusion of innovation and local excellence
              results in tailor-made solutions crafted for your business. Our
              team excels in creating personalized mobile apps that precisely
              align with your specific business needs and goals, ensuring a
              perfect fit. We continually lead in mobile technology trends,
              utilizing the latest tools and frameworks to create rich-featured
              and future-proof apps. Our commitment to your success extends
              beyond deployment, providing continuous maintenance and support to
              ensure seamless app operation.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
